<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary" to="/dashboard/pservice">add new item</router-link>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>عنوان</th>
                    <th>نوع درگاه</th>
                    <th>اولویت</th>
                    <th>وضعیت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="service in services" :key="service._id">
                    <td>{{ service.title }}</td>
                    <td>{{ serviceTypes[service.serviceType] }}</td>
                    <td>{{ service.priority }}</td>
                    <td>{{ service.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/pservice', query: { id: service._id } }"
                        >مشاهده</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
  </div>
</template>

<script>
import paymentServicesService from '../../../../services/paymentServices';
export default {
  name: 'league',
  data() {
    return {
      services: [],
      serviceTypes: {
        zarinpal: 'زرین پال',
        zibal: 'زی پال',
        parsian: 'پارسیان - مستقیم',
        sdk: 'sdk',
        rahpay: 'ره پی',
      },
    };
  },
  created() {
    this.getServices({});
  },
  methods: {
    async getServices(conditions) {
      try {
        const services = await paymentServicesService.getPurchaseServices(conditions);
        this.services = services;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
